import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaYoutube } from 'react-icons/fa6';
import { FaTiktok } from 'react-icons/fa';

const currentYear = new Date().getFullYear();

const Footer = () => {
    return (
        <footer
            className='py-5'
            style={{ backgroundColor: '#212529', color: 'white' }}
        >
            <div className='container'>
                <div className='row justify-content-center'>
                    {/* <div className="col-md-3">
                        <h3>PilotHelper</h3>
                        <p>PilotHelper draws distinction as one of the pioneers in the field of training and professional development solutions since 2025.</p>
                    </div> */}
                    <div className='col-md-3 mb-4 mb-md-0'>
                        <h3>CONTACT US</h3>
                        <p>
                            <a
                                href='mailto:contact@pilothelper.com'
                                className='text-white text-decoration-none'
                            >
                                contact@pilothelper.com
                            </a>
                        </p>
                    </div>
                    {/* <div className="col-md-3">
                        <h3>CATEGORIES</h3>
                        <ul className='list-unstyled'>
                            <li>Categories & Industries</li>
                            <li>Locations & Venues</li>
                            <li>Privacy Policy</li>
                            <li>Terms & Conditions</li>
                            <li>Frequently Asked Questions FAQs</li>
                        </ul>
                    </div> */}
                    <div className='col-md-3 mb-4 mb-md-0'>
                        <h3>HELPFUL LINKS</h3>
                        <ul className='list-unstyled'>
                            <li>
                                <Link to='/' className='text-white text-decoration-none'>
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to='/courses' className='text-white text-decoration-none'>
                                    Courses
                                </Link>
                            </li>
                            <li>
                                <Link to='/team' className='text-white text-decoration-none'>
                                    Team
                                </Link>
                            </li>
                            <li>
                                <Link to='/about' className='text-white text-decoration-none'>
                                    About
                                </Link>
                            </li>

                            <li>
                                <Link to='/contact' className='text-white text-decoration-none'>
                                    Contact
                                </Link>
                            </li>
                            <li>
                                <Link to='/privacy' className='text-white text-decoration-none'>
                                    Privacy Policy
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Social Media Section */}
                    <div className='col-md-3 mb-4 mb-md-0 text-center text-md-start'>
                        <h3>FOLLOW PILOTHELPER </h3>
                        <div className='d-flex justify-content-center justify-content-md-start align-items-center gap-3 mt-2'>
                            <a
                                href='https://www.instagram.com/pilothelper/?hl=en'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='text-white'
                                aria-label='Follow PilotHelper on Instagram'
                                style={{
                                    fontSize: '1.5rem',
                                    transition: 'opacity 0.3s ease',
                                    opacity: 0.9,
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.9')}
                            >
                                <FaInstagram aria-hidden='true' />
                            </a>
                            <a
                                href='https://www.tiktok.com/@mypilothelper'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='text-white'
                                aria-label='Follow PilotHelper on TikTok'
                                style={{
                                    fontSize: '1.5rem',
                                    transition: 'opacity 0.3s ease',
                                    opacity: 0.9,
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.9')}
                            >
                                <FaTiktok aria-hidden='true' />
                            </a>
                            <a
                                href='https://www.youtube.com/@Pilothelper'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='text-white'
                                aria-label='Follow PilotHelper on YouTube'
                                style={{
                                    fontSize: '1.5rem',
                                    transition: 'opacity 0.3s ease',
                                    opacity: 0.9,
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                                onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.9')}
                            >
                                <FaYoutube aria-hidden='true' />
                            </a>
                        </div>
                    </div>
                </div>
                <div className='row mt-4 pt-3 border-top border-secondary'>
                    <div className='col text-center opacity-75 small'>
                        Copyright © {currentYear} PilotHelper LLC. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
